import { useEffect } from "react";
const YukinChatbot = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const scriptId = "yukin-chatbot-script";
    if (document.getElementById(scriptId)) return;
    const script = document.createElement("script");
    script.id = scriptId;
    script.defer = true;
    script.src = "https://widget.yukin.ai/v3/embed.min.js?botId=7f5367e12f2743fdae46e92aa5fee399";
    script.onload = () => {
      console.log("Yukin Chatbot Loaded");
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return null; // No UI needed, script will handle rendering
};
export default YukinChatbot;